export default "__VITE_ASSET__06b3223b__"